import { ref, computed, Ref, ComputedRef } from 'vue';

import { Pokemon, Move } from '@/types';

export function useSearchedPokemonsByMoves(pokemons: Ref<Pokemon[]>): {
  searchMoveOne: Ref<Move | null>;
  searchMoveTwo: Ref<Move | null>;
  searchMoveThree: Ref<Move | null>;
  searchMoveFour: Ref<Move | null>;
  isSearchEmpty: ComputedRef<boolean>;
  searchedPokemons: ComputedRef<Pokemon[]>;
} {
  const searchMoveOne = ref<Move | null>(null);
  const searchMoveTwo = ref<Move | null>(null);
  const searchMoveThree = ref<Move | null>(null);
  const searchMoveFour = ref<Move | null>(null);

  const searchedPokemons = computed(() => {
    const searched = pokemons.value
      .filter((pokemon) =>
        searchMoveOne.value ? pokemon.moveIdLearnings.some((m) => m.id === searchMoveOne.value?.id) : true
      )
      .filter((pokemon) =>
        searchMoveTwo.value ? pokemon.moveIdLearnings.some((m) => m.id === searchMoveTwo.value?.id) : true
      )
      .filter((pokemon) =>
        searchMoveThree.value ? pokemon.moveIdLearnings.some((m) => m.id === searchMoveThree.value?.id) : true
      )
      .filter((pokemon) =>
        searchMoveFour.value ? pokemon.moveIdLearnings.some((m) => m.id === searchMoveFour.value?.id) : true
      );

    return searched;
  });

  const isSearchEmpty = computed(() => {
    return !searchMoveOne.value && !searchMoveTwo.value && !searchMoveThree.value && !searchMoveFour.value;
  });

  return {
    searchMoveOne,
    searchMoveTwo,
    searchMoveThree,
    searchMoveFour,
    isSearchEmpty,
    searchedPokemons,
  };
}
